export default __webpack_public_path__ + "static/media/casestudy-mathem.96c3a388.png";